import SegmentButton from 'ui-component/Segment/SegmentButton';
import { Box } from '@mui/material';
import { IconPlus } from '@tabler/icons-react';
import { ReactNode } from 'react';
import { PermissionScope } from 'types/apps';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';

const ContextualCreateButton = ({
  onClick,
  buttonMarginTop,
  children,
  boxAlignItems,
  disabled = false,
  permissionScope,
  sx,
  size = 'large',
}: {
  onClick: () => void;
  buttonMarginTop?: number;
  children?: ReactNode;
  boxAlignItems?: string;
  disabled?: boolean;
  permissionScope?: PermissionScope;
  sx?: SxProps<Theme>;
  size?: 'small' | 'medium' | 'large';
}) => {
  const buttonSize =
    size === 'small' ? 'small' : size === 'medium' ? 'medium' : 'large';
  const buttonDimensions =
    size === 'small' ? '32px' : size === 'medium' ? '40px' : '46px';

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        alignItems: boxAlignItems || 'center',
      }}
    >
      {children}
      <SegmentButton
        variant="outlined"
        startIcon={<IconPlus />}
        onClick={onClick}
        size={buttonSize}
        sx={
          sx ?? {
            '&.MuiButton-outlined': {
              width: buttonDimensions,
              height: buttonDimensions,
              minWidth: buttonDimensions,
              marginLeft: '10px',
            },
            '& .MuiButton-startIcon': {
              margin: 0,
            },
            mt: buttonMarginTop || 0,
          }
        }
        disabled={disabled}
        permissionScope={permissionScope}
      />
    </Box>
  );
};
export default ContextualCreateButton;
